<!--
/**
* @name: Detail.vue
* @description: 配额管理-添加/编辑、详情页面
* @author: yangbo@yuouhui1.com
* @create: 2022/06/09 11:46:58
* @update: 2022/06/09 11:46:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <template v-if="showType == 1">
      <y-query spaceBetween :hasSearchButton="false" style="margin-bottom: 0;">
        <y-query-item slot="right">
          <k-button type="primary" @click="onExport">导出配额信息</k-button>
        </y-query-item>
      </y-query>
      <y-form titleAlign="right" titleWidth="80px" contentWidth="100%">
        <y-form-item title="商品名称:" required align="top">
          <div :class="css.inputW">{{ editPara.goodsNameSale }}</div>
        </y-form-item>
        <y-form-item title="商品货号:" required>
          <div :class="css.inputW">{{ editPara.goodsCodeSale }}</div>
        </y-form-item>
        <y-form-item title="物料编码:" required>
          <div :class="css.inputW">{{ editPara.goodsCode }}</div>
        </y-form-item>
        <y-form-item title="总配额数:" required>
          <div :class="css.inputW">{{ editPara.quotaTotalNumer }}</div>
        </y-form-item>
        <y-form-item title="已使用/未使用:" required>
          <div :class="css.inputW">{{ editPara.useTotalNumber }}/{{ editPara.surplusTotalNumber }}</div>
        </y-form-item>
        <y-form-item title="规则名称:" required>
          <div :class="css.inputW">{{ editPara.title }}</div>
        </y-form-item>
        <y-form-item title="规则有效期:" required>
          <div :class="css.inputW">{{ editPara.validityTime[0] }} - {{ editPara.validityTime[1] }}</div>
        </y-form-item>
        <y-form-item title="配额批次:" required>
          <div :class="css.inputW">{{ editPara.batchNo }}</div>
        </y-form-item>
        <y-form-item title="门店配额:" align="top" required>
          <div style="margin-top: 5px;">
            <k-table class="mt-1" :data="popupPara.storeList" has-index height="530px" :rightFixedNumber="1" :columns="initColumns()"></k-table>
            <k-pagination :total="popupPara.total" :current-page.sync="popupPara.pageCurrent" :page-size.sync="popupPara.pageSize" @page-change="onChangePageIndex" />
          </div>
        </y-form-item>
      </y-form>
    </template>
    <template v-else>
      <y-form titleAlign="right" titleWidth="80px" contentWidth="100%">
        <y-form-item title="商品名称:" required align="top">
          <div :class="css.inputW">{{ editPara.goodsNameSale }}</div>
        </y-form-item>
        <y-form-item title="商品货号:" required>
          <div :class="css.inputW">{{ editPara.goodsCodeSale }}</div>
        </y-form-item>
        <y-form-item title="物料编码:" required>
          <div :class="css.inputW">{{ editPara.goodsCode }}</div>
        </y-form-item>
        <y-form-item title="总配额数:" required>
          <div :class="css.inputW">{{ editPara.quotaTotalNumer }}</div>
        </y-form-item>
        <y-form-item title="已使用/未使用:" required>
          <div :class="css.inputW">{{ editPara.useTotalNumber }}/{{ editPara.surplusTotalNumber }}</div>
        </y-form-item>
        <y-form-item title="规则名称:" required>
          <k-input :class="css.inputW" placeholder="请输入规则名称，30个字符内" maxlength="30" block v-model="editPara.title" clearable></k-input>
        </y-form-item>
        <y-form-item title="规则有效期:" required>
          <DatePicker
            :editable="false"
            ref="DatePicker"
            type="datetimerange"
            @on-change="changeDate"
            :value="editPara.validityTime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择"
            :class="css.inputW"
          ></DatePicker>
        </y-form-item>
        <y-form-item title="门店配额:" align="top" required>
          <div style="margin-top: 5px;">
            <y-query spaceBetween :hasSearchButton="false">
              <y-query-item>
                <k-input placeholder="请输入门店编码" clearable v-model="popupPara.shopCode"></k-input>
              </y-query-item>
              <y-query-item>
                <k-button type="primary" @click="onSearch">搜 索</k-button>
              </y-query-item>
              <y-query-item>
                <k-button @click="onReset">重 置</k-button>
              </y-query-item>
              <y-query-item slot="right" style="overflow: hidden;">
                <a href="javascript:;" @click="onDownLoadTemplate" style="margin: 4px 50px 0 0;">下载导入模板</a>
                <y-upload-file style="width: 60px;" acceptType=".xls,.xlsx" :uploadUrl="uploadUrl" @uploaded="onBatchImport">
                  <a href="javascript:;">批量导入</a>
                </y-upload-file>
              </y-query-item>
            </y-query>
          </div>
        </y-form-item>
        <y-form-item title="配额批次:" required>
          <k-select clearable block v-model="editPara.batchNo" :class="css.inputW">
            <k-option v-for="item in batchList" :key="item.saleBatchNo" :selected="editPara.batchNo == item.saleBatchNo"
              :value="item.saleBatchNo" :label="item.saleBatchNo">{{ item.saleBatchNo }}</k-option>
          </k-select>
      </y-form-item>
        <y-form-item title=" ">
          <div class="text-danger flex"><k-icon name="k-icon-tip" class="mr-1"></k-icon>在当前配额规则中，未导入的门店表示该门店不能售卖该商品的批次</div>
        </y-form-item>
        <y-form-item title="  ">
          <k-table class="mt-1" :data="popupPara.storeList" has-index height="520px" :rightFixedNumber="1" :columns="initColumns()"></k-table>
          <k-pagination :total="popupPara.total" :current-page.sync="popupPara.pageCurrent" :page-size.sync="popupPara.pageSize" @page-change="onChangePageIndex" />
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom">
      <k-button type="default" @click="onCancel(true, false)">取 消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus" v-if="showType != 1">保 存</k-button>
    </div>
  </y-view>
</template>
<script>
import {
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_ADD,
  NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_EDIT,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_DETAIL,
  NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_IMPORTSHOP,
  NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_GETGOODSQUOTA,
  NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_EXPORT_QUOTA_DETAIL,
  NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_GETGOODSQUOTADETAIL,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_DETAIL_BY_IDENTIFY,
  NESTLE_SUPPLY_BACK_SERVER_SALE_GET_BY_GOODS_CODE,
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_EXPORT
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  id: "",
  title: "",
  goodsId: "",
  goodsCodeSale: "",
  goodsNameSale: "",
  goodsCode: "",
  validityTime: "",
  quotaTotalNumer: 0,
  useTotalNumber: 0,
  surplusTotalNumber: 0,
  batchNo: "",
  versions: ''
});
const initPopupPara = () => ({
  shopCode: "",
  storeList: [],
  total: 0,
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      showType: 0,
      isLoading: false,
      isSaving: false,
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      storeList: [],
      allStoreList: [],
      editPara: initEditPara(),
      popupPara: initPopupPara(),
      batchList: [],
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (this.showType != 1) {
        let title = para.title.toString().replace(/\s*/g, "");
        if (!title || !para.validityTime || this.allStoreList.length === 0) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {},
  methods: {
    /** 返回配额管理列表页 */
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      setTimeout(() => {
        this.$controller.open(
          {
            name: "quotaManagement",
            query: {
              refresh: isRefresh ? new Date() - 0 : 0,
              id: this.editPara.goodsId,
            },
            title: "配额管理",
          },
          isClose ? this.$root.$router.currentRoute.name : undefined
        );
      }, 200);
    },

    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w ? w : 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },

    /** 初始化表格 */
    initColumns() {
      let tableItem = [
        { name: "门店编码", style: this.tableStyle(80), customRender: (row) => <div>{row.shopCode ? row.shopCode : "——"}</div> },
        { name: "门店名称", style: this.tableStyle(160), customRender: (row) => <div>{row.shopName ? row.shopName : "——"}</div> },
        {
          name: "配额数量",
          style: this.tableStyle(80),
          customRender: (row) => {
            if (this.showType == 1) {
              return <div>{row.quotaCount ? row.quotaCount : "0"}</div>;
            } else {
              return (
                <k-input
                  onBlur={() => {
                    this.onCheckquotaCount(row);
                  }}
                  class={this.css.widthAuto}
                  v-model={row.quotaCount}
                  placeholder="请输入"
                ></k-input>
              );
            }
          },
        },
        { name: "已用数量", style: this.tableStyle(80), customRender: (row) => <div>{row.useCount ? row.useCount : "0"}</div> },
        { name: "剩余数量", style: this.tableStyle(80), customRender: (row) => <div>{row.surplusCount ? row.surplusCount : "0"}</div> },
      ];
      return tableItem;
    },

    /** 检验输入的配额数量是否为正整数 */
    onCheckquotaCount(row) {
      if (row.quotaCount) {
        let reg = /(^[0-9]\d*$)/;
        if (!reg.test(row.quotaCount)) {
          row.quotaCount = 0;
          return this.$root.tip("配额数量必须大于等于0", "error");
        }
        row.surplusCount = row.quotaCount - row.useCount;
        let [quotaTotalNumer, useTotalNumber, surplusTotalNumber] = [0, 0, 0];
        for (var i = 0; i < this.allStoreList.length; i++) {
          if (typeof this.allStoreList[i].quotaCount == "string") {
            useTotalNumber += parseInt(this.allStoreList[i].useCount);
            quotaTotalNumer += parseInt(this.allStoreList[i].quotaCount);
            surplusTotalNumber += parseInt(this.allStoreList[i].surplusCount);
          } else if (typeof this.allStoreList[i].quotaCount == "number") {
            useTotalNumber += this.allStoreList[i].useCount;
            quotaTotalNumer += this.allStoreList[i].quotaCount;
            surplusTotalNumber += this.allStoreList[i].surplusCount;
          }
        }
        this.editPara.useTotalNumber = useTotalNumber;
        this.editPara.quotaTotalNumer = quotaTotalNumer;
        this.editPara.surplusTotalNumber = surplusTotalNumber;
        this.$forceUpdate();
      }
    },

    changeDate(time) {
      this.editPara.validityTime = time;
      if (time.length && time[0] && time[1]) {
        // 没有选择时间就默认23:59:59
        if (this.editPara.validityTime[1].slice(-8) === "00:00:00") {
          this.editPara.validityTime[1] = this.editPara.validityTime[1].replace(this.editPara.validityTime[1].substring(11, 19), "23:59:59");
        }
      }
      this.$refs["DatePicker"].internalValue = this.editPara.validityTime;
    },

    /** 下载导入模板 */
    onDownLoadTemplate() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_DETAIL_BY_IDENTIFY,
        para: { identify: "tpl_quota_import" },
        filename: "返利规则设置导入模板",
      })
        .then((res) => {
          window.open(encodeURI(res.value));
        })
        .catch(() => {});
    },

    onSearch() {
      let temp = [];
      for (let i = 0; i < this.allStoreList.length; i++) {
        if (this.popupPara.shopCode == this.allStoreList[i].shopCode) {
          temp.push(this.allStoreList[i]);
          break;
        }
      }
      this.popupPara.storeList = temp;
      this.popupPara.total = temp.length;
    },

    onReset() {
      this.popupPara.shopCode = "";
      this.popupPara.storeList = this.storeList[0];
      this.popupPara.total = this.allStoreList.length;
    },

    /** 批量导入门店配额 */
    onBatchImport(data) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_IMPORTSHOP,
        para: { excelUrl: data.data[0].url },
      })
        .then((res) => {
          this.isLoading = false;
          this.popupPara.total = res.length;
          this.allStoreList = res || [];
          this.$root.tip("门店配额导入成功", "success");
          let temp = [];
          var len = 15; //截取的数量
          let [quotaTotalNumer, useTotalNumber, surplusTotalNumber] = [0, 0, 0];
          for (var i = 0; i < res.length; i++) {
            var arr = res.slice(i, i + 15);
            temp.push(arr);
            i = i + len - 1;
          }
          for (var i = 0; i < res.length; i++) {
            useTotalNumber += res[i].useCount;
            quotaTotalNumer += res[i].quotaCount;
            surplusTotalNumber += res[i].surplusCount;
          }
          this.storeList = temp || [];
          this.popupPara.storeList = temp[0] || [];
          this.editPara.useTotalNumber = useTotalNumber;
          this.editPara.quotaTotalNumer = quotaTotalNumer;
          this.editPara.surplusTotalNumber = surplusTotalNumber;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    onChangePageIndex(p) {
      this.popupPara.storeList = this.storeList[p - 1];
    },

    /** 保存配额规则信息 */
    onSave() {
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (this.isSaving) return;
      this.isLoading = true;
      this.isSaving = true;
      let params = { id: this.editPara.id, goodsId: this.editPara.goodsId, startTime: this.editPara.validityTime[0], endTime: this.editPara.validityTime[1], title: this.editPara.title, batchNo: this.editPara.batchNo,versions: this.editPara.versions };
      if (this.showType == 0) {
        params.goodsQuotaDetailAddDTOList = this.allStoreList;
      } else if (this.showType == 2) {
        params.goodsQuotaDetailEditDTOList = this.allStoreList;
      }
      this.$fetch({
        api: para.id ? NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_EDIT : NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_ADD,
        para: params,
      })
        .then(() => {
          this.isSaving = false;
          this.isLoading = false;
          this.$root.tip("操作成功", "success");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },

    /** 获取主数据商品详情 */
    getGoodsDetail(goodsId, id) {
      if (!id) this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_DETAIL,
        para: { id: goodsId },
      })
        .then((res) => {
          this.editPara.goodsCode = res.goodsCode;
          this.editPara.goodsCodeSale = res.goodsCodeSale;
          this.editPara.goodsNameSale = res.goodsNameSale;
          this.getBatchList(res.goodsCodeSale);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 获取配额详情信息 */
    getGoodsQuotaDetail(id) {
      this.isLoading = true;
      this.$fetch({ api: NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_GETGOODSQUOTA, para: { id: id } })
        .then((res) => {
          this.editPara.title = res.title;
          this.editPara.validityTime = [res.startTime, res.endTime];
          this.editPara.batchNo = res.batchNo;
          this.editPara.versions = res.versions;
          this.$fetch({ api: NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_GETGOODSQUOTADETAIL, para: { goodsQuotaId: id } })
            .then((resq) => {
              this.popupPara.total = resq.length;
              this.allStoreList = resq || [];
              let temp = [];
              var len = 15; //截取的数量
              let [quotaTotalNumer, useTotalNumber, surplusTotalNumber] = [0, 0, 0];
              for (var i = 0; i < resq.length; i++) {
                var arr = resq.slice(i, i + 15);
                temp.push(arr);
                i = i + len - 1;
              }
              for (var i = 0; i < resq.length; i++) {
                useTotalNumber += resq[i].useCount;
                quotaTotalNumer += resq[i].quotaCount;
                surplusTotalNumber += resq[i].surplusCount;
              }
              this.storeList = temp || [];
              this.popupPara.storeList = temp[0] || [];
              this.editPara.useTotalNumber = useTotalNumber;
              this.editPara.quotaTotalNumer = quotaTotalNumer;
              this.editPara.surplusTotalNumber = surplusTotalNumber;
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 导出配额信息 */
    onExport() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_EXPORT_QUOTA_DETAIL,
        para: { goodsQuotaId: this.editPara.id },
        isBlob: true,
        filename: "配额信息详情",
      })
        .then((res) => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    getBatchList(code) {
      this.isLoading  = true;
      this.$fetch({
        api: NESTLE_SUPPLY_BACK_SERVER_SALE_GET_BY_GOODS_CODE,
        para: { goodsSaleCode: code },
      }).then((res) => {
        this.isLoading = false;
        this.batchList = res;
      }).catch(() => {
        this.isLoading = false;
      })
    }
  },
  async created() {
    const { id, goodsId, showType } = this.$route.query;
    this.editPara = initEditPara();
    this.popupPara = initPopupPara();
    this.storeList = [];
    this.allStoreList = [];
    this.editPara.goodsId = goodsId;
    this.editPara.id = id;
    this.showType = showType;
    this.getGoodsDetail(goodsId, id);
    if (id) this.getGoodsQuotaDetail(id);
  },

  beforeRouteUpdate(to, from, next) {
    const { id, goodsId, showType } = to.query;
    this.editPara = initEditPara();
    this.popupPara = initPopupPara();
    this.storeList = [];
    this.allStoreList = [];
    this.editPara.goodsId = goodsId;
    this.editPara.id = id;
    this.showType = showType;
    this.getGoodsDetail(goodsId, id);
    if (id) this.getGoodsQuotaDetail(id);
    next();
  },
};
</script>
<style module="css" lang="postcss">
.inputW {
  width: 500px !important;
}
.tableW {
  width: 100%;
}
.widthAuto {
  width: -webkit-fill-available;
}
</style>
